<template>
  <div
    class="overflow-hidden bg-white-100 w-auto p-1 rounded-xl group flex flex-col justify-between gap-16 relative md:min-h-[500px]"
    :class="{
      'card-shadow': card.is_highlighted,
    }"
  >
    <div>
      <div
        class="relative flex flex-col min-h-auto lg:min-h-[260px] gap-3 p-4 border border-gray-800 rounded-xl md:mb-5 overflow-hidden"
        :class="{
          'card-shadow border-green-200/60': card.is_highlighted,
        }"
      >
        <div class="absolute right-2.5 top-2.5 flex items-center">
          <div
            v-if="card.is_highlighted"
            class="relative bg-[#DDC3EF] flex-y-center text-center rounded-2xl py-px px-5 text-xs font-semibold flex-shrink-0"
          >
            {{ $t("popular") }}
          </div>
        </div>
        <div class="flex items-start gap-1">
          <div
            class="w-6 h-6 flex-y-center justify-center object-cover"
            v-html="card?.svg_icon"
          />
          <span
            class="text-xl font-interDisplay font-semibold leading-130 text-dark-300"
          >
            {{ $t(card?.title) }}
          </span>
        </div>
        <div class="flex flex-col items-start">
          <div class="flex flex-col items-start gap-2">
            <div class="flex flex-col items-start">
              <div
                class="flex-y-center gap-1"
                v-if="card.title === 'Starter' || card.title === 'Standart'"
              >
                <div class="flex items-end gap-2 font-interDisplay">
                  <div
                    class="flex-y-center"
                    :class="{
                      'mb-px': card?.price_year > 0,
                    }"
                  >
                    <span
                      class="leading-130 text-2xl text-gray-380 font-medium line-through"
                    >
                      {{
                        isCurrentTab === "monthly"
                          ? card?.price_month > 0
                            ? `$${
                                card.title === "Starter"
                                  ? formatMoneyDecimal(29, 0)
                                  : formatMoneyDecimal(49, 0)
                              }`
                            : $t("free")
                          : card?.price_year > 0
                            ? `$${
                                card.title === "Starter"
                                  ? formatMoneyDecimal(299 / 12, 0)
                                  : formatMoneyDecimal(499 / 12, 0)
                              }`
                            : $t("free")
                      }}
                    </span>
                  </div>
                </div>
                <div
                  class="flex-y-center justify-center gap-1 bg-[#4489f7]/10 text-[#2980b9] text-center rounded-md py-px px-2 text-xs font-semibold"
                >
                  <span class="icon-discount text-base" />
                  {{ $t("discount") }}
                </div>
              </div>
              <div
                class="flex items-end gap-2 font-interDisplay"
                :class="{
                  'lineargradient-text': card?.is_highlighted,
                }"
              >
                <div
                  class="flex-y-center"
                  :class="{
                    'mb-px': card?.price_year > 0,
                  }"
                >
                  <span
                    v-if="!card?.is_free"
                    class="leading-130 text-[40px] text-dark-300 font-bold"
                  >
                    {{
                      isCurrentTab === "monthly"
                        ? card?.price_year > 0
                          ? `$${formatMoneyDecimal(card?.price_month, 0)}`
                          : $t("free")
                        : card?.price_year > 0
                          ? `$${formatMoneyDecimal(card?.price_year / 12, 0)}`
                          : $t("free")
                    }}
                  </span>
                  <span
                    v-else
                    class="leading-130 text-[40px] text-dark-300 font-bold"
                  >
                    {{ `${0}$` }}
                  </span>
                  <span
                    v-if="card?.price_year > 0"
                    class="text-gray-380 leading-130 text-2xl ml-1"
                    >/
                    {{
                      isCurrentTab === "monthly"
                        ? $t("month").toLowerCase()
                        : $t("month").toLowerCase()
                    }}
                  </span>
                </div>
              </div>
            </div>
            <div class="text-gray-450 text-xs mt-auto">
              <p>
                {{ $t("plan_commission") + ": " }}
                <strong>{{ card?.commission_percent + "%" }}</strong>
              </p>
              <p>{{ $t("only_closed_trades") }}</p>
            </div>
          </div>
        </div>
        <a
          href="https://app.sarafrobot.com/"
          target="_blank"
          class="relative mt-auto flex w-full"
        >
          <Button
            variant="primary"
            size="sm"
            class="w-full mt-auto"
            text="Buy Now"
          />
        </a>
      </div>
      <ul class="text-base font-normal p-2">
        <li
          v-for="(listItem, listIndex) in planTexts"
          :key="listIndex"
          class="flex-y-center gap-1.5 mb-3 last:mb-0 pl-0.5"
        >
          <svg
            class="inline-flex w-6 h-6 shrink-0 fill-[#32ae60]"
            width="24"
            height="24"
            viewBox="0 0 24 24"
          >
            <path
              d="M12 1c6.075 0 11 4.925 11 11s-4.925 11-11 11S1 18.075 1 12 5.925 1 12 1zm3.793 7.293L10.5 13.586l-2.293-2.293a1 1 0 0 0-1.414 1.414l3 3a1 1 0 0 0 1.414 0l6-6a1 1 0 0 0-1.414-1.414z"
            ></path>
          </svg>
          <template v-if="listItem.type">
            <span class="text-sm font-semibold">
              <span>{{ $t(listItem?.text) }}: </span>
              <span
                class="inline-flex items-center gap-1 text-[#16cc53] font-medium"
              >
                <span>{{ listItem?.min }}</span> -
                <span class="icon-unlimited text-lg" />
              </span>
              <span class="text-xs text-[#16cc53]"> USDT</span>
            </span>
          </template>
          <template v-else>
            <span
              class="plan-info text-sm font-semibold"
              :class="{
                'text-[#2980b9] !font-normal': listItem?.type === 'bold',
              }"
              v-html="$t(listItem.text)"
            ></span>
          </template>
        </li>
      </ul>
    </div>
  </div>
</template>

<script setup lang="ts">
import { formatMoneyDecimal } from "@/utils";
import { computed } from "vue";
import { useI18n } from "vue-i18n";
import Button from "@/modules/Landing/components/Base/Button/Button.vue";

interface SubscriptionCard {
  id: number;
  title: string;
  description: string;
  type: string;
  price_year: number;
  price_month?: number;
  icon_url?: string;
  max_assign_money: string;
  min_assign_money?: string;
  is_highlighted?: boolean;
  is_default?: boolean;
  number_of_analysis: number;
  is_main: boolean;
  texts?: {
    id: number;
    text: string;
    is_included: boolean;
  }[];
  is_included?: boolean;
  included_services: string[];
  excluded_services: string[];
}

interface Props {
  card: SubscriptionCard;
  index: number;
  isCurrentTab?: string;
}
const props = defineProps<Props>();

const { t } = useI18n();

const planTexts = computed(() => {
  return [
    {
      text: t("assigned_usdt"),
      min: formatMoneyDecimal(props?.card?.min_assign_money, 0),
      max: formatMoneyDecimal(props?.card?.max_assign_money, 0),
      type: "bold",
    },
    ...props.card.texts,
  ];
});
</script>

<style>
.plan-info strong {
  font-weight: 500 !important;
}
</style>
<style scoped>
.card-shadow {
  -webkit-box-shadow: 0px 23px 47px -15px rgba(22, 204, 83, 0.2);
  -moz-box-shadow: 0px 23px 47px -15px rgba(22, 204, 83, 0.2);
  box-shadow: 0px 23px 47px -15px rgba(22, 204, 83, 0.2);
}
.round {
  background-color: #16cc53;
  opacity: 0.4;
  filter: blur(125px);
  width: 220px;
  height: 220px;
  position: absolute;
  top: -112px;
  right: -140px;
}
.lineargradient-text {
  background: linear-gradient(123deg, #16ccb6 8.66%, #16cc53 119.91%);
  background-clip: text;
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
}
.lineargradient {
  background: linear-gradient(
    123deg,
    #16ccb6 8.66%,
    #16cc53 119.91%
  ) !important;
}
</style>
